import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { AvailableSubscriptionsResult, QUERY_KEYS } from '@24i/nxg-sdk-photon/src';
import { log } from '@24i/nxg-core-utils/src/logger';
import { usePurchaseData } from '@24i/nxg-sdk-smartott-shared/src/context/PurchaseData';
import { useFirebase } from '@24i/nxg-sdk-smartott-shared/src/context/Firebase';

const useAvailableSubscriptionsQuery = (
    options?: UseQueryOptions<AvailableSubscriptionsResult>
): UseQueryResult<AvailableSubscriptionsResult> => {
    const { fetchAvailableSubscriptions } = usePurchaseData();
    const { recordError } = useFirebase();

    return useQuery<AvailableSubscriptionsResult>(
        QUERY_KEYS.availableSubscriptions,
        () => fetchAvailableSubscriptions(),
        {
            ...options,
            onError: (error) => {
                log(error);
                recordError?.(error);
                options?.onError?.(error);
            },
        }
    );
};

export default useAvailableSubscriptionsQuery;
